import { gql } from '@apollo/client';
import { ErrorMessageInfo } from '@retainerclub/shared-api';
import { PartnerTaxExemptionInfo } from '../fragments';

export default gql`
  mutation ActionPartnerTaxExemptionStatus(
    $input: PartnerTaxExemptionStatusActionInput!
  ) {
    actionPartnerTaxExemptionStatus(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      partnerTaxExemption {
        ...PartnerTaxExemptionInfo
      }
    }
  }
  ${ErrorMessageInfo}
  ${PartnerTaxExemptionInfo}
`;
